/**
 * Item types supported by VRL
 * @type {Object}
 */
export const itemTypes = {
  image: ['JPG', 'JPEG', 'PNG', 'PSD', 'TIF', 'TIFF'],
  audio: ['MP3'],
};

export const itemHeight = {
  image(nodeDimensions, { height = 400, width = 400 } = {}) {
    if (!nodeDimensions) {
      return 0;
    }

    const ratio = height / width;

    return Math.round(nodeDimensions.width * ratio);
  },
  audio() {
    return 100;
  },
};

/**
 * Guess the item type (image, audio, ...) based on type provided by backend
 * @param  {Object} item Item description provided by backend
 * @return {String}      Item type
 */
export const getItemType = (item) => {
  let itemType = '';

  Object.keys(itemTypes).some((type) => {
    if (itemTypes[type].includes(item.type.toUpperCase())) {
      itemType = type;
      return true;
    }
    return false;
  });

  return itemType;
};

/**
 * Determine if all the items contained in a transfer can be shown as grid
 * Grid displayed only when in a transfer there are at least 2 items of which one is previewable
 * @param  {Array}   items List of items part of the transfer
 * @return {Boolean}
 */

export const canBeShownAsGrid = (items = []) => {
  return (
    items.length > 1 &&
    items.some(({ previewable }) => previewable === true) &&
    items.every(
      ({ content_identifier }) => content_identifier !== 'web_content'
    )
  );
};
